import React from "react";
import PropTypes from "prop-types";
import BulkShareModal from "@components/show_page/bulk_actions/BulkShareModal";

class ShareAsset extends React.Component {
  state = {
    showModal: false
  };

  resetShowModal = () => {
    this.setState({ showModal: false });
  }

  render() {
    const assetKeysArray = [];
    assetKeysArray[0] = this.props.assetKey;

    return (
      <a onClick={(e) => {
        if (!this.state.showModal) {
          e.preventDefault();
          this.setState((prevState) => ({ showModal: !prevState.showModal }));
        }
      }}
      >
        <button className="button secondary sm share-button" type="button">
          <div className="attachment-icon">
            <span className="bff-share" aria-hidden="true" />
          </div>
          {t('Share')}
          {this.state.showModal
            ? (
              <BulkShareModal
                resetShowModal={this.resetShowModal}
                selectedAssetKeys={new Set(assetKeysArray)}
              />
            )
            : null
          }
        </button>
      </a>
    );
  }
}

ShareAsset.propTypes = {
  assetKey: PropTypes.string.isRequired
};


export default ShareAsset;
